import { render } from "./CatSerieView.vue?vue&type=template&id=c5fa3c16&scoped=true"
import script from "./CatSerieView.vue?vue&type=script&lang=js"
export * from "./CatSerieView.vue?vue&type=script&lang=js"

import "./CatSerieView.vue?vue&type=style&index=0&id=c5fa3c16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5fa3c16"]])

export default __exports__